import React, { useEffect, useState } from 'react';
import VideoPlayer from '../../../../routes/newVideo/VideoPlayer/VideoPlayer';
import { generateTextPanelsArray, generateTransitionsArray } from '../../../../utils/SimulatedItemsUtility';
import VideoSubtitles from '../../../../components/VideoSubtitles/VideoSubtitles';
import styles from './SubtitlesPlayer.module.scss';
import SubtitlesHelper from '../../../../utils/SubtitlesHelper';

const SubtitlesPlayer = ({ video, subtitles, handlePlayerProgress, seekToSubtitleValue, text, videoChapters, videoConfig }) => {
  const [isControlsVisible, setIsControlsVisible] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [simulate, setSimulate] = useState({});
  const [subtitlesSettings, setSubtitlesSettings] = useState(null);

  useEffect(() => {
    let simulatedLogo = false;
    let simulatedTextPanel = false;
    if (video.simulatedResources?.includes('*')) {
      simulatedTextPanel = true;
      simulatedLogo = true;
    } else {
      simulatedTextPanel = video.simulatedResources?.includes('textpanel');
      simulatedLogo = video.simulatedResources?.includes('logo');
    }

    let textPanels = [];

    const sortedScenes = video.scenes.sort((a, b) => a.sort - b.sort);

    if (simulatedTextPanel) {
      textPanels = generateTextPanelsArray(sortedScenes, video.introMeta?.duration);
    }

    let transitionsArray = [];
    if (video.transitions?.length > 0) {
      transitionsArray = generateTransitionsArray(sortedScenes, video.transitions, video.introMeta?.duration);
    }

    let mixedOrientation = false;
    if (simulatedTextPanel || simulatedLogo) {
      mixedOrientation = Array.from(new Set(video.scenes.map(item => item.orientation))).length > 1;
    }

    let resolvedSubtitlesSettings = videoConfig?.subtitlesSettings;
    setSubtitlesSettings(SubtitlesHelper.appendMarginYForOrientation(resolvedSubtitlesSettings, video.orientation));

    setSimulate({ logo: simulatedLogo, mixedOrientation, transitionsArray, textPanels });
  }, [video]);

  return (
    <div className={styles.wrapper}>
      <VideoPlayer
        uuid={video.id}
        originalURL={video.video}
        thumbnailURL={video.thumbnail}
        scenes={video.scenesData}
        overlay
        videoDuration={video.duration}
        handleProgressChange={handlePlayerProgress}
        seekToSecondExternal={seekToSubtitleValue}
        isFullScreenAllowed={false}
        enableSubtitles={false}
        showSubtitlesExistance={true}
        subtitles={subtitles}
        subtitlesSettings={subtitlesSettings}
        controlsVisibilityChanged={setIsControlsVisible}
        handleTogglePlaying={setIsVideoPlaying}
        textPanels={simulate.textPanels}
        logo={simulate?.logo && videoConfig?.logo}
        transitionsArray={simulate.transitionsArray}
        intro={video.introMeta}
        outro={video.outroMeta}
        mixedOrientation={simulate.mixedOrientation}
        chapters={videoChapters}
        videoConfig={videoConfig}
      />
      <VideoSubtitles
        subtitlesSettings={subtitlesSettings}
        text={text}
        videoControlsVisible={isControlsVisible || !isVideoPlaying}
        className={styles.subtitles}
      />
    </div>
  );
};

export default SubtitlesPlayer;
